import { SET_CATEGORY } from './actions'
import { CATEGORY_DEFAULT } from '../../const/categories'

const initialState = {
  parent: CATEGORY_DEFAULT || '',
  id: CATEGORY_DEFAULT || '',
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CATEGORY.REQUEST:
      const { parent, id } = action.payload
      return { ...state, parent: parent || id, id }
    default:
      return state
  }
}
